import React from "react"
import { nanoid } from "nanoid"

export const useId = (prefix: string = "") =>
  React.useState(`${prefix}${nanoid()}`)[0]

export default useId
